module.exports = {"addButtonText":"生成","settingType":"設定類型","wafRuleList":"白名單","isEnabled":"啟用","editWafRule":"編輯白名單","addWafRule":"新增白名單","reachMaxWafRuleListLength":"最多僅能新增 {maxWafRuleListLength} 條白名單","wafRuleModalFormValidationError":"請完成表單內容","addText":"新增條件","collapseText":"收合","wafRule":{"name":{"label":"名稱","placeholder":"白名單名稱"},"isEnabled":{"label":"啟用"},"rules":{"label":"規則","rule":{"type":"類別","name":"名稱","isPositive":"符合"}}}}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-TW/intelligentProtectionSettings.json
// module id = Qcbz
// module chunks = 3